import React from 'react';
import { FaUser } from "react-icons/fa";
import styles from "../../../../styles/office/EditModal.module.css";

const ApplicantInfoSection = ({ language, localRecord, renderReadOnlyField }) => (
  <div className={styles.section}>
    <h3 className={styles.sectionTitle}>
      <FaUser className={styles.sectionIcon} />
      {language === 'en' ? 'Applicant Information' : 'अर्जदाराची माहिती'}
    </h3>
    {renderReadOnlyField(language === 'en' ? 'Applicant Name' : 'अर्जदाराचे नाव', localRecord.applicantName)}
    {renderReadOnlyField(language === 'en' ? 'Email' : 'ईमेल', localRecord.applicantEmail)}
    {renderReadOnlyField(language === 'en' ? 'Mobile Number' : 'मोबाइल', localRecord.applicantMobile)}
    {renderReadOnlyField(language === 'en' ? 'Address' : 'पत्ता', localRecord.applicantAddress)}
  </div>
);

export default ApplicantInfoSection;